import React from 'react';
import './LoadingLogo.scss';

// Route-level loading fallback shown by <Suspense> while a lazy page chunk
// is being fetched. It is mounted only for the duration of the load and is
// unmounted automatically by Suspense once the page is ready — so it never
// needs its own hide timer (a timer causes a white flash if the page is
// still loading when it fires).
function LoadingLogo() {
  return (
    <div className="loading-logo">
      <div className="loading-crown">
        <div className="loading-ring" aria-hidden="true" />
        <span className="loading-om">द्रां</span>
      </div>
      <p className="loading-chant">॥ श्री गुरुदेव दत्त ॥</p>
    </div>
  );
}

export default LoadingLogo;